import { POSTWithAuthNoResponse } from './Index'

export async function Whitelist(): Promise<void> {
  return await POSTWithAuthNoResponse(
    `https://athena-${process.env.NEXT_PUBLIC_ENVIRONMENT}.glassapi.xyz/creators/whitelist`,
    {}
  )
}
